import Vue from 'vue';
import Router from 'vue-router';
import bowser from 'bowser';
import PersonalRouter from './router/personal'; //登录后的页面的路由
Vue.use(Router);
import Layout from '@/layout/index.vue';
const HelloWorld = (r) =>
  require.ensure(
    [],
    () => r(require('./components/HelloWorld.vue')),
    'helloWorld',
  );
const pdf = (r) =>
  require.ensure([], () => r(require('./components/pdf.vue')), 'pdf');
const tro = (r) =>
  require.ensure([], () => r(require('./components/tro.vue')), 'tro');
const Home = (r) =>
  require.ensure([], () => r(require('./components/home/Home.vue')), 'home');

const DepositCertificate = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/deposit/depositCertificate.vue')),
    'depositCertificate',
  );
const Signing = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/deposit/signing.vue')),
    'Signing',
  );
const Transfer = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/deposit/transfer.vue')),
    'Transfer',
  );
const PersonalCenter = (r) =>
  require.ensure(
    [],
    () => r(require('./components/personal/PersonalCenter.vue')),
    'personalIndex',
  );
const Verification = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/Verification.vue')),
    'Verification',
  );
const About = (r) =>
  require.ensure([], () => r(require('./components/home/About.vue')), 'About');
const MobileAbout = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/mobileAbout.vue')),
    'MobileAbout',
  );
const LookCertificate = (r) =>
  require.ensure(
    [],
    () => r(require('./components/personal/sign/lookCertificate.vue')),
    'LookCertificate',
  );

const Login = (r) =>
  require.ensure([], () => r(require('./components/home/Login.vue')), 'Login');
const Solution = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/Solution.vue')),
    'Solution',
  );

const HelpCenter = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/helpCenter.vue')),
    'HelpCenter',
  );

const Register = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/Register.vue')),
    'Register',
  );
const Validate = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/Validate.vue')),
    'Validate',
  );
const ValidateResult = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/validate/validateResult.vue')),
    'ValidateResult',
  );

const Forgetpwd = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/register/Forgetpwd.vue')),
    'Forgetpwd',
  ); //忘记密码
const paySuccess = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/paySuccess.vue')),
    'paySuccess',
  ); //忘记密码

let routes = [
  {
    path: '',
    redirect: '/home',
    component: Layout,
    children: [
      {
        path: '/home',
        component: (resolve) => require(['@/views/home.vue'], resolve),
        name: '主页',
      },
      {
        path: '/news',
        component: (resolve) => require(['@/views/news/index.vue'], resolve),
        name: '新闻速递',
      },
      {
        path: '/partners',
        component: (resolve) =>
          require(['@/views/partners/index.vue'], resolve),
        name: '合作伙伴',
      },
      {
        path: '/register',
        component: (resolve) =>
          require(['@/views/register/index.vue'], resolve),
        name: '注册',
      },
      {
        path: '/corp',
        component: (resolve) => require(['@/views/corp/index.vue'], resolve),
        name: '公司介绍',
      },
      {
        path: '/blockChain',
        component: (resolve) =>
          require(['@/views/blockChain/index.vue'], resolve),
        name: '区块链',
      },
      {
        path: '/try',
        component: (resolve) => require(['@/views/try/index.vue'], resolve),
        name: '试用',
      },
    ],
  },
  {
    path: '/helpCenter',
    name: '帮助中心',
    component: Layout,
    children: [
      {
        path: 'fingerPost',
        component: (resolve) =>
          require(['@/views/helpCenter/fingerPost.vue'], resolve),
        name: '操作指南',
      },
      {
        path: 'issues',
        component: (resolve) =>
          require(['@/views/helpCenter/issues.vue'], resolve),
        name: '专业问题',
      },
    ],
  },
  {
    path: '/product',
    component: Layout,
    // component: (resolve) => require(['@/views/corp'], resolve),
    children: [
      {
        path: 'fq',
        component: (resolve) => require(['@/views/product/fq.vue'], resolve),
        name: '赋强',
      },
      {
        path: 'existingEvidence',
        component: (resolve) =>
          require(['@/views/product/existingEvidence.vue'], resolve),
        name: '存证',
      },
      {
        path: 'signing',
        component: (resolve) =>
          require(['@/views/product/signing.vue'], resolve),
        name: '签约',
      },
      {
        path: 'mediate',
        component: (resolve) =>
          require(['@/views/product/mediate.vue'], resolve),
        name: '调解',
      },
    ],
  },
  {
    path: '/programme',
    component: Layout,
    // component: (resolve) => require(['@/views/corp'], resolve),
    children: [
      {
        path: 'blockchainPlan',
        component: (resolve) =>
          require(['@/views/programme/blockchainPlan.vue'], resolve),
        name: '区块链存证',
      },
      {
        path: 'fqPlan',
        component: (resolve) =>
          require(['@/views/programme/fqPlan.vue'], resolve),
        name: '金融赋强公证',
      },
      {
        path: 'litigation',
        component: (resolve) =>
          require(['@/views/programme/litigation.vue'], resolve),
        name: '诉调一体化',
      },
    ],
  },

  {
    path: '/world',
    component: HelloWorld, //demo用，暂时别删
  },
  {
    path: '/tro',
    component: tro, //拖拽
  },
  {
    path: '/pdf',
    component: pdf, //拖拽
  },
  {
    path: '/home',
    component: Home,
    children: [
      {
        path: 'depositCertificate',
        component: DepositCertificate,
        name: 'DepositCertificate',
      },
      {
        path: 'signing',
        component: Signing,
        name: 'Signing',
      },
      {
        path: 'transfer',
        component: Transfer,
        name: 'Transfer',
      },
    ],
  },
  {
    path: '/lookCertificate',
    component: LookCertificate,
  },
  {
    path: '/solution',
    component: Solution,
  },
  {
    path: '/verification',
    component: Verification,
    children: [
      {
        path: 'about',
        component: About,
      },

      {
        path: 'validate',
        component: Validate,
      },
      {
        path: 'validateResult',
        component: ValidateResult,
      },
      {
        path: 'login',
        component: Login,
      },
      {
        path: 'paySuccess',
        component: paySuccess,
      },
      {
        path: 'register',
        component: Register,
      },
      {
        path: 'forgetpwd',
        component: Forgetpwd,
      },
      {
        path: 'helpCenter',
        component: HelpCenter,
      },
    ],
  },
  {
    path: '/personal',
    component: PersonalCenter,
    children: [PersonalRouter],
  },
  {
    path: '/mobileAbout',
    component: MobileAbout,
  },
];

let router = new Router({
  mode: 'history',
  base: '/',
  routes,
  // 对于页面跳转，全部都返回到页面顶部。
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  //  [
  //   {
  //     path: '/',
  //     redirect: '/home',
  //   },
  //   {
  //     path: '/world',
  //     component: HelloWorld, //demo用，暂时别删
  //   },
  //   {
  //     path: '/tro',
  //     component: tro, //拖拽
  //   },
  //   {
  //     path: '/pdf',
  //     component: pdf, //拖拽
  //   },
  //   {
  //     path: '/home',
  //     component: Home,
  //     children: [
  //       {
  //         path: 'depositCertificate',
  //         component: DepositCertificate,
  //         name: 'DepositCertificate',
  //       },
  //       {
  //         path: 'signing',
  //         component: Signing,
  //         name: 'Signing',
  //       },
  //       {
  //         path: 'transfer',
  //         component: Transfer,
  //         name: 'Transfer',
  //       },
  //     ],
  //   },
  //   {
  //     path: '/lookCertificate',
  //     component: LookCertificate,
  //   },
  //   {
  //     path: '/solution',
  //     component: Solution,
  //   },
  //   {
  //     path: '/verification',
  //     component: Verification,
  //     children: [
  //       {
  //         path: 'about',
  //         component: About,
  //       },

  //       {
  //         path: 'validate',
  //         component: Validate,
  //       },
  //       {
  //         path: 'validateResult',
  //         component: ValidateResult,
  //       },
  //       {
  //         path: 'login',
  //         component: Login,
  //       },
  //       {
  //         path: 'paySuccess',
  //         component: paySuccess,
  //       },
  //       {
  //         path: 'register',
  //         component: Register,
  //       },
  //       {
  //         path: 'forgetpwd',
  //         component: Forgetpwd,
  //       },
  //       {
  //         path: 'helpCenter',
  //         component: HelpCenter,
  //       },
  //     ],
  //   },
  //   {
  //     path: '/personal',
  //     component: PersonalCenter,
  //     children: [PersonalRouter],
  //   },
  //   {
  //     path: '/mobileAbout',
  //     component: MobileAbout,
  //   },
  // ],
});
// 拦截所有前端请求
router.beforeEach((to, from, next) => {
  const remPath = ['/helpCenter', '/product', '/programme'];
  let flag = false;
  remPath.forEach((ele) => {
    if (to.path.includes(ele) || to.path == '/home') {
      flag = true;
    }
  });
  function getHtmlFontSize() {
    document.documentElement.style.fontSize =
      document.body.clientWidth / 37.5 + 'px' || '19.2px';
  }
  if (document.body.clientWidth > 778) {
    next();
    return (document.documentElement.style.fontSize = 'unset');
  }
  if (flag) {
    getHtmlFontSize();
    window.addEventListener('resize', getHtmlFontSize);
  } else {
    document.documentElement.style.fontSize = 'unset';
    window.removeEventListener('resize', getHtmlFontSize);
  }

  next();
});

// 处理懒加载导致路由跳转问题
// router.onError((error) => {
//   const targetPath = router.history.pending.fullPath;
//   window.location.href = targetPath;
//   if (bowser.msie) {
//     window.location.reload();
//   }
// });
export default router;
